/**
 * Small helpers for authoring slice rules and their truth fixtures (reviewed code). They only build
 * data; the rule record and every fixture are plain, hashed content.
 */
/** Fixture clock: every fixture is judged at this instant, its observations an hour earlier. */
export const FIXTURE_NOW = '2026-10-13T12:00:00.000Z';
export const FIXTURE_COLLECTED = '2026-10-13T11:00:00.000Z';
export const DAY_S = 86_400;
/** Inputs older than two daily sweeps are stale. */
export const FRESH_S = 2 * DAY_S;
export const GCP_PROJECT = { resource_key: 'gcp:projects/gacpro-sandbox', resource_type: 'gcp.project', environment: 'production' };
export const GCP_ORG = { resource_key: 'gcp:organizations/42', resource_type: 'gcp.organization', environment: 'production' };
export const D1_DB = { resource_key: 'cloudflare:d1/0f9e8d7c-6b5a-4c3d-9e2f-1a0b9c8d7e6f', resource_type: 'cloudflare.d1_database', environment: 'production' };
/** An observation as a fixture holds it (defaults: ok, complete, collected an hour before FIXTURE_NOW). */
export function obs(path, value, value_type, source_api, more = {}) {
    return {
        path, element_key: null, value, value_type, source_api, collected_at: FIXTURE_COLLECTED,
        status: 'ok', complete: true, error_code: null, error_detail: null,
        redaction_class: value_type === 'int' ? 'count_only' : 'internal_config', ...more,
    };
}
/** The same input, read but not usable (denied, truncated, not enabled, …). */
export function unread(path, value_type, source_api, status, error_code = null, complete = false) {
    return obs(path, null, value_type, source_api, { status, complete, error_code });
}
export function fixture(kind, name, resource, observations, expect, params) {
    return { kind, name, resource, observations, ...(params ? { params } : {}), now: FIXTURE_NOW, expect };
}
export const GCP_TYPES = ['gcp.project', 'gcp.organization'];
export const AUTHOR = 'agent:v109-track3';
export function ref(framework, r, kind, reach, rationale) {
    return { framework, ref: r, kind, reach, rationale };
}
/** A rule's content with the slice defaults (authored; version 1; cites the provider API docs; DISA searched). */
export function authored(c) {
    return { version: 1, source_role: 'cited', origin: 'authored', technology_versions: '*', ...c };
}
export const eqTrue = (path) => ({ op: 'eq', path, operand: { value: true } });
export const eqZero = (path) => ({ op: 'eq', path, operand: { value: 0 } });
/** LM-26: rules authored after the first catalog release (R20). */
export const AUTHOR_TRACK7 = 'agent:v109-track7';
//# sourceMappingURL=kit.js.map